import React from 'react';

export default function DetailsSkeleton() {
  return (
    <div className="min-h-screen bg-dark-900 animate-pulse pb-16">
      {/* Hero Section Skeleton */}
      <div className="w-full h-[50vh] md:h-[60vh] bg-dark-800 relative shadow-xl"></div>
      
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 -mt-48 relative z-10">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Poster Skeleton */}
          <div className="shrink-0">
            <div className="w-48 md:w-56 rounded-xl bg-dark-700 shadow-2xl border border-dark-400 aspect-[2/3] animate-pulse"></div>
          </div>
          
          {/* Info Skeleton */}
          <div className="flex-1 pt-4 space-y-4">
            <div className="h-10 bg-dark-700 rounded-lg w-1/2 animate-pulse mt-12 md:mt-0"></div>
            
            {/* Meta Row Skeleton */}
            <div className="flex gap-3">
              <div className="w-12 h-5 bg-dark-700 rounded-full animate-pulse"></div>
              <div className="w-20 h-5 bg-dark-700 rounded-full animate-pulse"></div>
              <div className="w-16 h-5 bg-dark-700 rounded-full animate-pulse"></div>
            </div>
            
            {/* Overview Skeleton */}
            <div className="space-y-2 max-w-2xl pt-4">
              <div className="h-4 bg-dark-700 rounded w-full animate-pulse"></div>
              <div className="h-4 bg-dark-700 rounded w-5/6 animate-pulse"></div>
              <div className="h-4 bg-dark-700 rounded w-4/6 animate-pulse"></div>
              <div className="h-4 bg-dark-700 rounded w-full animate-pulse"></div>
            </div>
            
            {/* Action Buttons Skeleton */}
            <div className="flex gap-3 pt-6">
              <div className="w-28 h-12 bg-dark-700 rounded-full animate-pulse"></div>
              <div className="w-32 h-12 bg-dark-700 rounded-full animate-pulse"></div>
              <div className="w-36 h-12 bg-dark-700 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
        
        {/* Cast/Crew Row Skeleton */}
        <div className="mt-16 pt-8 border-t border-dark-700/50">
          <div className="w-32 h-6 bg-dark-700 rounded-md mb-6 animate-pulse"></div>
          <div className="flex gap-6 overflow-hidden">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-20 h-20 rounded-full bg-dark-700 mb-3 animate-pulse"></div>
                <div className="w-16 h-3 bg-dark-700 rounded-md mb-2 animate-pulse"></div>
                <div className="w-12 h-2 bg-dark-700 rounded-md animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
